import React, { useEffect } from "react";
import { preLoaderAnim } from "../animations";
import '../preloader.scss';

const PreLoader = () => {
  useEffect(() => {
    preLoaderAnim();
  }, []);
  return (
    <div className="preloader">
      <div className="texts-container">
        <span>Trip</span>
        <span>to</span>
        <span>Kosovo</span>
      </div>
    </div>
  );
};

export default PreLoader;